import Link from '@/shared/components/shared/Link';

const linkProps = {
    className: 'link link--underlined',
    target: '_blank',
    rel: 'noreferrer nofollow',
} as const;

const PersonalDataConsentLabel = () => (
    <>
        Даю{' '}
        <Link href="/agreement/" {...linkProps}>
            Согласие
        </Link>{' '}
        на обработку персональных данных в соответствии с{' '}
        <Link href="/privacy/" {...linkProps}>
            Политикой
        </Link>
    </>
);

export default PersonalDataConsentLabel;
